import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { AddOnsViewProvider } from 'pages/settings/pages/addOns/context/addOnsViewContext'

const AddOnsPageLayoutContent = () => {
  return <Outlet />
}

export const AddOnsPageLayout = observer(() => {
  return (
    <AddOnsViewProvider>
      <AddOnsPageLayoutContent />
    </AddOnsViewProvider>
  )
})
